var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"modal",attrs:{"id":"bulk-transfer-modal","modal-class":"modal-fullscreen","centered":"","scrollable":"","size":"lg","title":"Bulk transfer","hide-footer":""}},[_c('BulkTransferForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }